/**
 * Extracts the visitor ID from FingerprintJS Pro result
 * Главный ID который отправляешь на backend для идентификации пользователя
 */
export const getVisitorId = (data: any): string | null => {
  return data?.visitorId || null;
};

/**
 * Extracts the request ID (для server-side верификации)
 * Используется бэкендом чтобы验证 что ID настоящий
 */
export const getRequestId = (data: any): string | null => {
  return data?.requestId || null;
};

/**
 * Проверяет уровень уверенности (0.01 - 1.0)
 * Выше 0.95 = очень надёжный ID
 */
export const isHighConfidence = (data: any, minConfidence: number = 0.95): boolean => {
  if (!data?.confidence?.score) return false;
  return data.confidence.score >= minConfidence;
};

/**
 * Форматирует данные для отправки в API
 * ГЛАВНАЯ ФУНКЦИЯ - её используешь в App.tsx
 */
export const formatFingerprintForAPI = (data: any) => {
  return {
    fingerprint: getVisitorId(data) || '',
    requestId: getRequestId(data) || '',
    confidence: data?.confidence?.score || null,
  };
};

/**
 * Логирует данные в console (только в development)
 */
export const logFingerprintData = (data: any, label: string = 'FingerprintJS Pro'): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`[${label}]`, {
      visitorId: getVisitorId(data),
      requestId: getRequestId(data),
      confidence: data?.confidence?.score,
      error: data?.error,
    });
  }
};

/**
 * Проверяет готовность данных
 */
export const isFingerprintReady = (data: any, isLoading: boolean): boolean => {
  return !isLoading && !!getVisitorId(data);
};

/**
 * Обработка ошибок FingerprintJS
 */
export const handleFingerprintError = (error: any): string => {
  if (!error) return '';
  const errorMessage = error?.message || 'Unknown error occurred';
  if (process.env.NODE_ENV === 'development') {
    console.error('[FingerprintJS Pro Error]', error);
  }
  return errorMessage;
};
